<template>
  <div>
    <div class="header">
      <div class="logo">
        <div class="logo_left">
          <img src="../../assets/jpg/srkenvue.png" alt />
          <!-- <p>FAMILY OF CONSUMER COMPANIES</p> -->
        </div>
        <div class="logo_right">
          <p>WWID:{{ this.wwid }}</p>
          <p>用户名:{{ this.name }}</p>
        </div>
      </div>

      <!-- <div class="navFirst">
        <div class="tianFirst" :class="{ isActive: firstType == 'Sales' }">
          <p @click="changeFirst('Sales')">Sales</p>
        </div>
        <div class="posFirst" :class="{ isActive: firstType == 'Inventory' }">
          <p @click="changeFirst('Inventory')">
            Inventory <br />
            <span class="posFirstLittle"> Calculate </span>
          </p>
        </div>
      </div> -->

      <div class="nav">
        <div
          v-if="firstType == 'Sales'"
          class="tian"
          :class="{ isActive: tabName == 'Sales-Channel' }"
          @click="change('Sales-Channel')"
        >
          <p>{{ PosTit }}</p>
        </div>
        <div
          v-if="firstType == 'Sales'"
          class="pos"
          :class="{ isActive: tabName == 'Sales-brand' }"
          @click="change('Sales-brand')"
        >
          <p>{{ TmallTit }}</p>
        </div>
        <!-- <div
          v-if="firstType == 'Sales'"
          class="pos"
          :class="{ isActive: tabName == 'EC-VIEW' }"
          @click="change('EC-VIEW')"
        >
          <p>EC VIEW</p>
        </div> -->

        <div
          v-if="firstType == 'Inventory'"
          class="tian"
          :class="{ isActive: tabName == 'Inventory-Channel' }"
          @click="change('Inventory-Channel')"
        >
          <p>{{ PosTit }}</p>
        </div>
        <div
          v-if="firstType == 'Inventory'"
          class="pos"
          :class="{ isActive: tabName == 'Inventory-brand' }"
          @click="change('Inventory-brand')"
        >
          <p>{{ TmallTit }}</p>
        </div>
        <!-- <div
          v-if="firstType == 'Inventory'"
          class="pos"
          :class="{ isActive: tabName == 'EC-VIEW' }"
          @click="change('EC-VIEW')"
        >
          <p>EC VIEW</p>
        </div> -->
      </div>
      <div
        style="line-height: 25px;
    text-align: right;
    padding-right: 10px;color: #f3f3f3;margin-top: -15px;font-family: '微软雅黑' !important;"
        v-show="tabName == 'EC-VIEW'"
      >
        更新时间：{{ this.updateTime | dateFormat }}
      </div>

      <!-- 原来的 -->
      <!-- <div class="nav" @click="change">
        <div class="tian" :class="{ isActive: flag }">
          <p>{{ PosTit }}</p>
        </div>
        <div class="pos" :class="{ isActive: !flag }">
          <p>{{ TmallTit }}</p>
        </div>
      </div> -->
      <!-- 原来的 -->
    </div>
    <div class="container" id="container">
      <MyMask ref="change"></MyMask>

      <!-- 公告栏 -->
      <van-overlay :show="show" z-index="99999">
        <div class="wrapper" @click.stop>
          <div class="block">
            <h4 style="margin: 30px auto 10px; font-weight: bold">公告</h4>
            <p
              style="
                text-align: left;
                color: rgb(121, 121, 121);
                font-size: 14px;
                padding: 5px 10px;
                line-height: 26px;
                margin: -3px auto 18px;
                display: block;
                width: 85%;
              "
              v-html="messageTie"
            ></p>
            <van-button
              size="large"
              block
              style="
                border-radius: 0px 0px 8px 8px;
                height: 52px;
                line-height: 52px;
              "
              @click="show = false"
            >
              <span>
                <p
                  style="
                    color: rgb(103, 109, 143);
                    font-size: 18px;
                    margin-top: -10px;
                  "
                >
                  <b>我知道了</b>
                </p>
              </span>
            </van-button>
          </div>
        </div>
      </van-overlay>

      <!-- <transition v-if="firstType== 'Sales'">
        <div v-if="flag">
          <Summary></Summary>
        </div>
        <div v-else>
          <Bu></Bu>
        </div>
      </transition> -->

      <transition>
        <div v-if="tabName == 'Sales-Channel'">
          <Summary></Summary>
        </div>
        <div v-else-if="tabName == 'Sales-brand'">
          <Bu></Bu>
        </div>
        <div v-else-if="tabName == 'Inventory-Channel'">
          <SummaryIC></SummaryIC>
        </div>
        <div v-else-if="tabName == 'Inventory-brand'">
          <BuIC></BuIC>
        </div>
        <div v-if="tabName == 'EC-VIEW'">
          <Ecview></Ecview>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import Bu from "@/components/ButSecoend2/Bu/Buindex";
import Summary from "@/components/ButSecoend2/Summary/Summary";
import Ecview from "@/components/ButSecoend/Ecview/Summary";
import MyMask from "@/components/public/mask";

import BuIC from "@/components/ButSecoend2/Bu-IC/Buindex";
import SummaryIC from "@/components/ButSecoend2/Summary-IC/Summary";

import $ from "jquery";
import qs from "qs";

export default {
  name: "index",
  data() {
    return {
      updateTime: undefined,
      active: 0,
      flag: true,
      longFlag: false,
      name: "",
      wwid: "",
      PosTit: "Channel View",
      TmallTit: "Brand View",

      tabName: "Sales-Channel",
      firstType: "Sales",

      show: false,
      achVing: 0,
      messageTie: `<!--
<b>1. </b> 11/19为11月关帐日<br/>
<b>2. </b>11/20 - 11/23作最后财务调整,11月最终版本数据将于11/23更新<br/>
<b>3. </b>11/24月切至12月-->十二月战斗已打响！`
    };
  },
  methods: {
    getMsgNotice() {
      this.$addr
        .post("Log/getNotice", qs.stringify({ menuId: "2" }))
        .then(res => {
          if (res.data.data.isEffective == 1) {
            this.show = true;
            this.messageTie = res.data.data.notice;
          } else {
            this.show = false;
          }
        });
    },
    sendTime(menu) {
      var time = new Date();
      var y = time.getFullYear();
      var m = (time.getMonth() + 1).toString().padStart(2, "0");
      var d = time
        .getDate()
        .toString()
        .padStart(2, "0");
      var h = time
        .getHours()
        .toString()
        .padStart(2, "0");
      var mm = time
        .getMinutes()
        .toString()
        .padStart(2, "0");
      var s = time
        .getSeconds()
        .toString()
        .padStart(2, "0");
      var EndTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
      const sendEnd = {
        startDate: EndTime,
        endDate: "",
        wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
        name: JSON.parse(sessionStorage.getItem("userInfo")).name,
        menu: "Sales Report",
        operationModule: menu
      };
      this.$addr.post("Log/insert", qs.stringify(sendEnd)).then(res => {});
    },

    changeFirst(name) {
      this.firstType = name;
      if (name == "Sales") {
        this.tabName = "Sales-Channel";
      } else {
        this.tabName = "Inventory-Channel";
      }
    },

    change(tabName) {
      this.tabName = tabName;
    },

    getUserInfo() {
      sessionStorage.setItem("long", "");
      sessionStorage.setItem("longFlag", false);
      if (sessionStorage.userInfo != undefined) {
        const user = JSON.parse(sessionStorage.userInfo);
        this.name = user.name;
        this.wwid = user.wwid;
      } else {
        this.$router.push({ path: "/" });
      }
    },

    async getUpdateTime() {
      const res = await this.$addr.get("ECDashboard/getLevel1List");
      if (res.data.error == 0) {
        this.updateTime = res.data.data[0]["upload_time"];
      }
    }
  },
  components: {
    MyMask,
    Summary,
    Bu,
    SummaryIC,
    BuIC,
    Ecview
  },
  created() {
    this.sendTime(this.PosTit);
    this.getUserInfo();
    this.getMsgNotice();
  },
  mounted() {
    this.getUpdateTime();
  },
  beforeRouteLeave(to, from, next) {
    var time = new Date();
    var y = time.getFullYear();
    var m = (time.getMonth() + 1).toString().padStart(2, "0");
    var d = time
      .getDate()
      .toString()
      .padStart(2, "0");
    var h = time
      .getHours()
      .toString()
      .padStart(2, "0");
    var mm = time
      .getMinutes()
      .toString()
      .padStart(2, "0");
    var s = time
      .getSeconds()
      .toString()
      .padStart(2, "0");
    var EndTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
    const sendEndObj = {
      startDate: "",
      endDate: EndTime,
      wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
      name: JSON.parse(sessionStorage.getItem("userInfo")).name,
      menu: "Sales Report"
    };
    this.$addr.post("Log/insert", qs.stringify(sendEndObj)).then(res => {
      next();
    });
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}

body {
  width: 100%;
  background-image: linear-gradient(
    -1deg,
    #eeeeee 22%,
    rgba(237, 237, 237, 0.98) 93%,
    rgba(216, 216, 216, 0) 100%
  );
  min-height: 100%;
  position: relative;
  /* box-sizing: border-box; */
}
.header {
  position: relative;
  padding-top: 35px;
  top: 0;
  z-index: 99;
  background-image: url("../../assets/jpg/bgkenvue.png");
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
  /* height: 200px; */
  /* height: 230px; */
  box-sizing: border-box;
  overflow: hidden;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-left: 35px;
  height: 35px;
  width: 100%;
  margin-bottom: 20px;
}
.logo_left {
  margin-left: -30px;
}
.logo .logo_left img {
  width: 280px;
  margin-bottom: 0.2%;
}
.logo_right {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 40px;
  height: 40px;
}
.logo_right p {
  font-family: "PingFangSC-Light";
  font-size: 12px;
  color: #ffffff;
  font-weight: bold;
}

.nav {
  width: 380px;
  height: 46px;
  margin: 30px auto;
  /* margin-top: 14px;
  margin-bottom: 14px; */
  border: 2px solid #ffffff;
  border-radius: 30px;
  box-shadow: inset -5px 0 20px 0 #912a23;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav .isActive {
  background: #ffffff;
  box-shadow: 5px 0 20px 0 #912a23;
  border-radius: 30px;
  min-width: 185px;
  height: 46px;
  color: #01B198 !important;
}

.navFirst .isActive {
  background: #ffffff;
  box-shadow: 5px 0 20px 0 #912a23;
  border-radius: 30px;
  min-width: 185px;
  height: 50px;
  color: #01B198 !important;
}

.navFirst {
  width: 420px;
  height: 50px;
  margin: 0 auto;
  margin-bottom: 20px;
  border: 2px solid #ffffff;
  border-radius: 30px;
  box-shadow: inset -5px 0 20px 0 #912a23;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.navFirst .tianFirst,
.navFirst .posFirst {
  min-width: 200px;

  font-family: "微软雅黑" !important;
  /* font-family: "PingFangSC-Medium"; */
  font-size: 15px;
  text-align: center;
  line-height: 16px;
  padding: 18px 30px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.posFirstLittle {
  font-size: 13px;
}

.nav .tian,
.nav .pos {
  min-width: 50%;
  font-family: "PingFangSC-Medium";
  font-size: 15px;
  text-align: center;
  line-height: 20px;
  /* padding: 20px 36px; */
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f6f6ff;
  box-shadow: inset 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 0 0 20px 20px;
  overflow: hidden;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 350px;
  min-height: 40px;
  line-height: 40px;
  background-color: #fff;
  text-align: center;
  font-size: 20px;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ButSecoend2/indexSec2.vue